import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { regionPatch } from "../../store/region/actions";
export var useRegionPatch = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePatchRegion: (_a = state.Region.responsePatchRegion) === null || _a === void 0 ? void 0 : _a.data,
            errorPatchRegion: state.Region.errorPatchRegion,
            loadingPatchRegion: state.Region.loadingPatchRegion,
        });
    }), responsePatchRegion = _a.responsePatchRegion, errorPatchRegion = _a.errorPatchRegion, loadingPatchRegion = _a.loadingPatchRegion;
    useEffect(function () {
        if (trigger) {
            dispatch(regionPatch(bodyRequest));
        }
    }, [bodyRequest, trigger]);
    return {
        responsePatchRegion: responsePatchRegion,
        errorPatchRegion: errorPatchRegion,
        loadingPatchRegion: loadingPatchRegion,
    };
};
